<div class="root-container" *ngIf="!!channel">
  <section class="wizard">
    <icn-wizard
      [header]="isCreate ? 'CREATE CHANNEL' : 'CHANNEL SETTINGS'"
      [stepTitle]="getStepsTitle()"
      [doneTitle]="getDoneTitle()"
      themeColor="cyan"
      [editMode]="edit"
      (apply)="onApply()"
      [applyState]="applyState"
    >
      <icn-wizard-step
        class="mt20"
        icon="/assets/icons/wiz-info-icon.svg"
        [name]="'INFO'"
        [beforeNextStep]="isCreate ? startCreate.bind(this) : undefined"
      >
        <icn-wizard-substep>
          <icn-channel-wizard-step1-substep1
            #substepContent
            [channelInfo]="channel"
            [title]="'Your channel name & description:'"
            [(name)]="channel.name"
            [(description)]="channel.description"
            [(timezoneId)]="channel.timezoneId"
            [(burnSubtitlesToVideo)]="channel.burnSubtitles"
            [(subtitleLanguage)]="channel.subtitleLanguage"
            [(subtitlesSettings)]="channel.subtitleFontSettings"
            [(framerate)]="channel.framerate"
            [(audioNormalizationValue)]="audioNormalizationValue"
            [uploadPlaylistCsvSettings]="channel.uploadPlaylistCsvSettings"
            [lufsChecked]="useLufsChecked"
            [(audioNormalizationChecked)]="audioNormalizationChecked"
            [(cuePeriodChecked)]="cuePeriodChecked"
            (useLufsCheckedChange)="useLufsChecked = $event"
            [(aspectRatio)]="channel.aspectRatio"
            [channelAsTemplateChecked]="channel.isTemplate"
            [(playSingleItemPerDepth)]="channel.playOneItemPerDepth"
            [allCategories]="allCategories"
            [selectedChannelCategories]="channel.templateCategories"
            [templateTrailerUrl]="channel.templateTrailerUrl"
            [mainLanguageCode]="channel.mainLanguageCode"
            [audioLangSettings]="channel.audioLangSettings"
            (audioLangSettingsChange)="channel.audioLangSettings = $event"
            [closedCaptions]="channel.closedCaptions"
            (closedCaptionsChange)="channel.closedCaptions = $event"
            [playbackOffset]="channel.playbackOffset"
            [autoExtendLiveShowBehaviour]="channel.autoExtendLiveShowBehaviour"
            (autoExtendLiveShowBehaviourChanged)="
              updateAutoExtendLiveShowBehaviour($event)
            "
            (playbackOffsetChanged)="channel.playbackOffset = $event"
            (channelAsTemplatedChanged)="
              channel.isTemplate = !channel.isTemplate
            "
            (templateTrailerUrlChanged)="channel.templateTrailerUrl = $event"
            (onMainLanguageChange)="channel.mainLanguageCode = $event"
            [channelIsRecordingActiveChecked]="channel.isRecordingActive"
            (channelIsRecordingChanged)="channel.isRecordingActive = $event"
          >
          </icn-channel-wizard-step1-substep1>
        </icn-wizard-substep>
      </icn-wizard-step>
      <icn-wizard-step
        icon="/assets/icons/wiz-logo-icon.svg"
        [name]="'LOGO & PLACEHOLDER'"
      >
        <icn-wizard-substep>
          <icn-channel-wizard-step1-substep2
            #substepContent
            [(packshotUrl)]="channel.packshotUrl"
            [(placeholderImage)]="channel.placeholderImage"
            [(logoX)]="channel.logoX"
            [(logoY)]="channel.logoY"
            [(logoHeight)]="channel.logoHeight"
            [(logoWidth)]="channel.logoWidth"
            [(logoZIndex)]="channel.logoZIndex"
            [channelId]="channel.id"
          >
          </icn-channel-wizard-step1-substep2>
        </icn-wizard-substep>
      </icn-wizard-step>

      <icn-wizard-step
        class="mt20"
        icon="/assets/icons/wiz-destribut-icon.svg"
        [name]="'DISTRIBUTION'"
      >
        <div class="availability-zone-field">
          <div class="text">Choose the availability zones for the channel:</div>
          <icn-dropdown
            [allowMultiple]="true"
            [position]="'bottom'"
            [(selectedValues)]="channel.availabilityZoneIds"
            (selectedValuesChange)="_bindRelevantEdgeServers()"
          >
            <icn-dropdown-item
              *ngFor="let availabilityZone of allActiveAvailabilityZones"
              [value]="availabilityZone.id"
              [title]="availabilityZone.displayName"
            >
            </icn-dropdown-item>
          </icn-dropdown>
        </div>
        <div class="availability-zone-field">
          <div class="text">Override channel settings:</div>
          <icn-dropdown
            [allowMultiple]="true"
            [showSettingsIcon]="true"
            [selectedValues]="channel.overrideChannelJsonAvailabilityZoneIds"
            (selectedValuesChange)="onOverrideChannelJsonZoneChanged($event)"
            (settingsIconClicked)="overrideChannelSettingsClicked($event)"
          >
            <icn-dropdown-item
              *ngFor="let availabilityZone of channelAvalabilityZones"
              [value]="availabilityZone.id"
              [title]="availabilityZone.displayName"
            >
            </icn-dropdown-item>
          </icn-dropdown>
          <ngx-smart-modal
            #channelJsonEditorModal
            identifier="channelJsonEditorModal"
            [@.disabled]="true"
            [customClass]="'nsm-centered'"
          >
            <evrideo-channel-json-editor
              *ngIf="channelJsonEditorVM"
              [vm]="channelJsonEditorVM"
            ></evrideo-channel-json-editor>
          </ngx-smart-modal>
        </div>

        <icn-wizard-substep
          [title]="'Choose where you want to distribute your channel:'"
        >
          <icn-channel-wizard-step2-substep1
            #substepContent
            [channelCodecs]="channelCodecs"
            [channelInfo]="channel"
            [channelPlatforms]="channel.platforms"
            [allEdgeServers]="relevantEdgeServers"
            (saveCodec)="saveCodec($event)"
            [burnSubtitlesToVideo]="channel.burnSubtitles"
          >
          </icn-channel-wizard-step2-substep1>
        </icn-wizard-substep>
      </icn-wizard-step>
      <icn-wizard-step
        icon="/assets/icons/wiz-promo-icon.svg"
        [name]="'DYNAMIC PROMO'"
        [title]="'DYNAMIC PROMO TIME SPOT'"
        [showStepInfo]="false"
        [beforeNextStep]="onFinish.bind(this)"
      >
        <icn-wizard-substep>
          <dynamic-promo-settings
            #substepContent
            [channel]="channel"
          ></dynamic-promo-settings>
        </icn-wizard-substep>
      </icn-wizard-step>
      <icn-wizard-step [isDoneStep]="true">
        <icn-wizard-substep>
          <icn-channel-wizard-done
            #substepContent
            [channel]="channel"
            [currentUser]="currentUser"
            [isCreate]="isCreate"
          ></icn-channel-wizard-done>
        </icn-wizard-substep>
      </icn-wizard-step>
    </icn-wizard>
  </section>
</div>
